import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { TagsApiService } from '../apis/tags-api.service';
import { Common } from '../lib/common-methods';
import { LocalStorageService } from '../lib/local-storage.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { Reservation } from '../model/reservation';
import { ReservationTag, ReservationTagCategory } from '../model/reservation-tag';
import { TagType } from '../model/tag-type';
import { createTagUpdateDTO } from '../model/tags.dto';
import * as AppActions from '../store/actions/app.actions';
@Component({
  selector: 'app-reservation-tag-modal',
  templateUrl: './reservation-tag-modal.component.html',
  styleUrls: ['./reservation-tag-modal.component.scss']
})
export class ReservationTagModalComponent implements OnInit, OnChanges {

  constructor(private translate: TranslateService,
    private tagsApi: TagsApiService,
    private localStorageService: LocalStorageService,
    private store: Store<{ reservations: Reservation[] }>) { }

  @ViewChild('modal') modal!: ModalDialogComponent;
  @Input() modalId: string = 'reservation-tag-modal';
  @Input() selectedTag: ReservationTag = new ReservationTag();
  @Input() categories: ReservationTagCategory[] = [];
  @Output() onClose: EventEmitter<ReservationTag> = new EventEmitter();
  @Input() tagType: TagType = "RESERVATION";

  isTagValid: boolean = false;
  tagErrorMessage: string = "";

  private tagStartOrder: number = 0;
  private tagStartName: string = "";

  ngOnInit(): void {

  }

  show(tag: ReservationTag) {
    this.modal.show();
    this.tagStartOrder = tag.tagOrder ?? 0;
    this.tagStartName = tag.title ?? "";
    this.updateValidity();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateValidity();
  }

  updateValidity() {
    const cat = this.categories.find(c => c.id == this.selectedTag?.categoryId);
    this.selectedTag.title = this.selectedTag?.title?.trim();

    this.tagErrorMessage = "";
    if (Common.isNullOrEmpty(this.selectedTag?.title) || cat == null) {
      this.tagErrorMessage = this.translate.instant('common.requiredFields');
    } else if (cat.tags.find(c => c.id != this.selectedTag.id && c.title == this.selectedTag.title) != null) {
      this.tagErrorMessage = this.translate.instant('common.nameIsUsed');
    }

    this.isTagValid = Common.isNullOrEmpty(this.tagErrorMessage);
  }

  modalClosed(ok: boolean): void {
    if (ok == false) {
      return;
    }

    this.tagModalClosed(this.selectedTag);
  }

  async tagModalClosed(tag: ReservationTag) {
    const cat = this.categories.find(c => c.id == tag.categoryId)!;
    const updateDto = createTagUpdateDTO(
      this.localStorageService.getRestaurantId() + "", cat, this.tagType, tag, this.tagStartOrder, this.tagStartName
    );
    if (updateDto == null) {
      return;
    }

    await firstValueFrom(this.tagsApi.saveTags(updateDto));

    this.store.dispatch({ type: AppActions.loadTags.type });
    this.onClose.emit(this.selectedTag);
  }

}
